module.exports = __webpack_public_path__ + "img/20180815_145911_028.c54371ce.jpg";